<div class="auth-page flex">
  <!--  Left-->
  <div class="flex flex-1 flex-column auth-left">
    <!-- Logo -->
    <div class="p-4 md:p-5">
      <img
        class="logo-image"
        src="/images/header_logo.svg"
        alt="Full Scale Solutions"
      />
    </div>
    <div class="flex-1 flex align-items-start md:align-items-center justify-content-center px-4 py-4 md:px-5">
      <form class="flex flex-column form-width" [formGroup]="form" (ngSubmit)="handleLogin()">
        <div class="display-sm-semibold text-gray-900">Dobrodošli</div>
        <div class="mt-2-5 text-md-regular text-gray-600">Prijavite se na svoj nalog.</div>
        <app-field label="Email" class="mt-5">
          <app-email-input
            ctrlPlaceholder="Unesite email adresu"
            [formCtrl]="form.controls['email'] | formControl"
          >
          </app-email-input>
        </app-field>
        <app-field label="Lozinka" class="mt-3-5">
          <app-text-input
            [hasIcon]="true"
            formCtrlType="password"
            ctrlPlaceholder="Unesite lozinku"
            [formCtrl]="form.controls['password'] | formControl"
          >
            <app-lock-03 stroke="#ADB0B8"></app-lock-03>
          </app-text-input>
        </app-field>
        <div class="mt-4 flex justify-content-end align-content-center text-sm-semibold text-gray-700 cursor-pointer"
             (click)="location.routeToForgotPass()">
          Zaboravljena lozinka?
        </div>
        <app-button class="mt-4" [btnType]="'submit'" [btnSize]="ButtonSize.MD">
          <div class="text-sm-semibold text-white">Prijavi se</div>
        </app-button>
        <div class="mt-5 flex justify-content-center align-content-center">
          <div class="text-sm-regular text-gray-600">Nemate nalog?</div>
          <div class="ml-1 text-sm-semibold text-gray-700 cursor-pointer" (click)="location.routeToRegister()">Registrujte se</div>
        </div>
      </form>
    </div>
    <div class="text-sm-regular text-gray-600 p-4 md:p-5">
      © Full Scale Solutions {{ currentYear }}
    </div>
  </div>
  <!--  Right-->
  <div class="hidden lg:flex flex-column justify-content-end right flex-1">
    <div class="flex flex-column right-text gap3">
      <div class="display-lg-medium">Vaša vizija.</div>
      <div class="display-lg-medium">Naš plan.</div>
      <div class="display-lg-medium">U prirodnoj veličini.</div>
    </div>
  </div>
</div>

